const n = (i) => "href" in i;
export {
  n as isLink
};
